import type { Translations } from './pt-BR';

const en: Translations = {
  nav: {
    dashboard:    'Home',
    forecast:     'Forecast',
    birthChart:   'Birth Chart',
    synastry:     'Synastry',
    questions:    'Ask the Stars',
    astromatch:   'AstroMatch',
    tarot:        'Tarot de Marseille',
    lenormand:    'Lenormand',
    numerology:   'Numerology',
    iChing:       'I Ching',
    dreamJournal: 'Dream Journal',
    moonPhases:   'Moon Phases',
    agenda:       'Astrological Agenda',
    retrograde:   'Retrograde Radar',
    eclipses:     'Eclipse Insight',
    astroPet:     'Astro Pet',
    astroCoach:   'Astro Coach',
    startAstral:  'Rota Profissional',
    empresas:     'Business',
    astrocartografia:    'Astrocartography',
    wallet:         'Wallet',
    readings:       'Readings',
    settings:       'Settings',
    signOut:        'Sign out',
    quiromancy:     'Palmistry',
    vedicAstrology: 'Vedic Astrology',
    humanDesign:    'Human Design',
    blog:           'Blog',
    pricing:        'Plans',
  },
  credits: {
    questions:  'Question credits',
    synastry:   'Synastry credits',
    astromatch: 'AstroMatch credits',
  },
  home: {
    heroBadge:       'Personalised for you. Not for your sign.',
    heroHeadline1:   'Astral',
    heroHeadline2:   'Secret.',
    heroSubheadline: 'Astrology, tarot, I Ching, numerology and more, revealed specifically for you.',
    heroCta1:        'Discover your Astral Secret →',
    heroCta2:        'See today\'s forecasts',
    heroSocialProof: '✦ Over 50,000 readings completed',
    heroScrollHint:  'See sign forecasts',

    signForecastTitle:    'Today\'s forecast',
    signForecastSubtitle: 'Select your sign to see what the stars have in store for today.',
    forecastToday:        'Today\'s forecast',
    forecastWeek:         'This week\'s forecast',
    forecastMonth:        'This month\'s forecast',
    consultingStars:      'Consulting the stars for {sign}...',
    starsMoving:          'The stars are in motion. Please try again in a moment ✦',
    seeFullForecast:      'See full forecast ✦',

    featureTitle:    'Everything you need, in one place',
    featureSubtitle: 'From daily forecasts to full birth charts, 3,000 years of tradition at your fingertips.',
    startFree:       'Start for free ✦',

    feat: {
      birthChartTitle:    'Birth Chart',
      birthChartDesc:     'Discover your planets, houses and aspects with a complete interpretation in English.',
      birthChartBadge:    'Premium',
      forecastTitle:      'Personalised Forecast',
      forecastDesc:       'Daily, weekly and monthly forecasts calculated from your natal chart.',
      synastryTitle:      'Synastry',
      synastryDesc:       'Compare your chart with someone special and see full compatibility.',
      synastryBadge:      'Premium',
      questionsTitle:     'Ask the Stars',
      questionsDesc:      'Ask any question and receive a personalised astrological answer.',
      astromatchTitle:    'AstroMatch',
      astromatchDesc:     'Upload a photo and discover astrological personality through physiognomy.',
      astromatchBadge:    'Exclusive',
      moreTitle:          'Tarot, I Ching & more',
      moreDesc:           'Tarot readings, I Ching, Numerology, Dream Journal and Moon Phases.',
    },

    premiumBadge:   '✦ Premium Plan',
    premiumTitle1:  'Dive deep',
    premiumTitle2:  'into your stars',
    premiumDesc:    'With Professya Premium you get the full birth chart, unlimited synastry, personalised forecasts and much more, for less than $1 per day.',
    premiumF1:      'Full birth chart with interpretation',
    premiumF2:      'Daily, weekly and monthly forecasts',
    premiumF3:      'Relationship synastry',
    premiumF4:      'Unlimited questions to the stars',
    premiumF5:      'AstroMatch by photo',
    premiumF6:      'Access to Tarot, I Ching and Numerology',
    premiumPrice:   '$4.99',
    premiumPer:     '/month',
    premiumCta:     'Subscribe now ✦',
    premiumCancel:  'Cancel anytime. No commitment.',

    demoLabel1: 'Birth Chart',
    demoSub1:   'Sun in Aries · Moon in Taurus · ASC Gemini',
    demoLabel2: 'Synastry',
    demoSub2:   '87% compatibility ✦ Venus in harmony',
    demoLabel3: 'Today\'s forecast',
    demoSub3:   '"Venus favours deep connections..."',

    servicesTitle:    'Our Services',
    servicesSubtitle: 'From daily forecasts to full birth charts, everything for your astrological self-discovery.',
    servicesCta:      'Access all services ✦',
    badgePlan:        'Plan',
    badgeCredits:     'Credits',
    badgeAvulso:      'One-off',
    badgeNew:         'New ✦',
    svc: {
      birthChart:  { name: 'Birth Chart',           subtitle: 'Your complete natal chart',                    description: 'Discover the exact position of all planets, houses and aspects at the moment of your birth. Not a generic horoscope, it\'s the unique chart only you possess.' },
      forecast:    { name: 'Personalised Forecast', subtitle: 'Daily, weekly, monthly and annual',            description: 'Forecasts calculated for YOUR natal chart, not your sun sign. Know exactly which planets are activating your life now and what to expect in the coming months.' },
      synastry:    { name: 'Synastry',              subtitle: 'Deep compatibility between two charts',        description: 'Analyse the real connection between two natal charts. Discover the aspects that create attraction, tension, karmic mission and long-term potential in any relationship.' },
      astroMatch:  { name: 'AstroMatch',            subtitle: 'Compatibility before the first meeting',      description: 'Enter a name, sign and some traits of someone and discover the astrological potential of that connection before getting involved. Save time and energy.' },
      astrocartografia: { name: 'Astrocartography',          subtitle: 'Where in the world you thrive',               description: 'Compare your natal chart with that of 195 countries and discover where you have the most potential for love, career, health and quality of life. Also analyses any specific city.' },
      questions:   { name: 'Ask the Stars',         subtitle: 'Direct answers from the oracle',              description: 'Ask any question and receive a personalised answer based on the planetary transits active in your natal chart at this exact moment.' },
      tarot:       { name: 'Tarot de Marseille',     subtitle: '4 spread types interpreted',                  description: 'Spreads of 1, 3, 7 and 10 cards with deep interpretation rooted in the classical Tarot de Marseille tradition, combined with your planet positions at the time of the reading.' },
      lenormand:   { name: 'Lenormand Oracle',      subtitle: 'The 36-card Gypsy oracle',                    description: 'The Lenormand oracle reveals hidden patterns in your life through its 36 cards. Choose from 1, 3, 5 or 9-card spreads for a personalised symbolic reading.' },
      numerology:  { name: 'Numerology',            subtitle: 'The numbers that govern your life',           description: 'Destiny, Soul, Personality and Personal Year numbers calculated from your full name and birth date. Discover the cycles that govern your journey.' },
      astroPet:    { name: 'Astro Pet',             subtitle: 'Your pet\'s natal chart',                     description: 'Calculate your pet\'s natal chart and discover their astrological personality. Also analyse the compatibility between you and your animal companion.' },
      startAstral: { name: 'Rota Profissional',          subtitle: 'Your vocation through the natal chart',       description: 'Full analysis of your Midheaven, Saturn, Jupiter and North Node to reveal your vocation, natural talents and the professional path most aligned with who you are.' },
      retrograde:  { name: 'Retrograde Radar',      subtitle: 'Real impact on your chart',                   description: 'Know exactly how Mercury, Venus, Mars and other retrograde planets affect YOUR natal chart, not a generic forecast by sign.' },
      eclipse:     { name: 'Eclipse Insight',       subtitle: 'Eclipses that activate your life',            description: 'Discover which houses and planets in your natal chart are activated by solar and lunar eclipses, and what this means for the next 6 months of your life.' },
    },
  },
  auth: {
    email:            'Email',
    password:         'Password',
    confirmPassword:  'Confirm password',
    signIn:           'Sign in',
    createAccount:    'Create account',
    forgotPassword:   'Forgot password',
    resetPassword:    'Reset password',
    noAccount:        'Don\'t have an account?',
    hasAccount:       'Already have an account?',
    orContinue:       'or continue with',
    sendReset:        'Send reset link',
    backToLogin:      'Back to login',
    checkEmail:       'Check your email for the reset link.',
    signInTitle:      'Sign in to your account',
    createTitle:      'Create your free account',
    name:             'Name',
    namePlaceholder:  'Your name',
    showPassword:     'Show password',
    hidePassword:     'Hide password',
    createFree:       'Create free account',
    createCta:        'Create account ✦',
    agreeText:        'By creating an account you agree to our',
    terms:            'Terms',
    privacyPolicy:    'Privacy Policy',
    biometricTitle:   '✦ Want to sign in faster?',
    biometricDesc:    'Enable Face ID / Touch ID to sign in to Professya without typing your password.',
    biometricEnable:  'Enable Face ID / Touch ID',
    biometricSkip:    'Not now',
    continueGoogle:   'Continue with Google',
    continueApple:    'Continue with Apple',
    oauthError:       'Authentication failed. Please try again.',
  },
  common: {
    loading:      'Loading...',
    error:        'Error',
    retry:        'Try again',
    save:         'Save',
    cancel:       'Cancel',
    back:         'Back',
    close:        'Close',
    confirm:      'Confirm',
    language:     'Language',
  },
  dashboard: {
    cosmicBrief:       '✦ Cosmic Brief',
    consultingStars:   'Consulting the stars for you...',
    starsMoving:       'The stars are in motion. Your cosmic brief will be ready in a moment ✦',
    completeBanner:    '✦ Complete your profile',
    completeBannerSub: 'Add your birth date for personalised readings.',
    addData:           'Add data',
    quickAccess:       'Quick access',
    continueJourney:   'Continue your journey',
    seeAll:            'See all',
    greetingMorning:   'Good morning',
    greetingAfternoon: 'Good afternoon',
    greetingEvening:   'Good evening',
    errorTitle:        'Something went wrong',
    errorSubtitle:     'We couldn\'t load your profile. Try refreshing the page.',
    reload:            'Refresh',
    suggBirthChartDesc: 'Discover your planets and astrological houses.',
    suggForecastTitle:  'Weekly forecast',
    suggForecastDesc:   'What the stars have in store for you this week.',
    suggQuestionsDesc:  'Ask your first question with 1 free credit.',
    premiumBadge:        'Premium active ✦',
    premiumWelcomeTitle: 'Welcome to Professya Premium!',
    premiumWelcomeDesc:  'Explore your first features.',
    premiumClose:        'Close',
    premiumStep1:        'Birth Chart',
    premiumStep2:        'Forecast',
    premiumStep3:        'Synastry',
    premiumStep4:        'AstroMatch',
    premiumStep5:        'Tarot',
    renewalTitle:        'Your subscription expires {when}',
    renewalToday:        'today',
    renewalTomorrow:     'tomorrow',
    renewalDays:         'in {days} days',
    renewalDesc:         'Renew now so you don\'t lose Premium access.',
    renewalCta:          'Renew ✦',
    tierPremium:         'Premium',
    streakSingular:      'consecutive day',
    streakPlural:        'consecutive days',
    creditQuestionsSingular: 'question',
    creditQuestionsPlural:   'questions',
    creditSynastry:          'synastry',
  },
  layout: {
    navSigns:      'Signs',
    navBlog:       'Blog',
    navPlans:      'Plans',
    navMyAccount:  'My Account',
    navSignIn:     'Sign in',
    navStartFree:  'Start free',
    footerTagline: 'Astrology and esotericism for your daily life.',
    footerProduct: 'Product',
    footerLegal:   'Legal',
    footerRights:  'All rights reserved.',
    footerMotto:   'Astral Secret',
    footerSignos:  'Signs',
    footerBirthChart: 'Birth Chart',
    footerSynastry:   'Synastry',
    footerQuestions:  'Questions',
    footerPrivacy:    'Privacy',
    footerTerms:      'Terms of use',
    footerLgpd:       'Data policy',
    footerBrandTagline:  'Professya, Your self-knowledge revealed through astrology, tarot, I Ching and much more.',
    footerServices:      'Services',
    footerOracles:       'Oracles',
    footerForecast:      'Forecast',
    footerAstroMatch:    'AstroMatch',
    footerAstrocartografia:   'Astrocartography',
    footerStartAstral:   'Rota Profissional',
    footerTarot:         'Tarot',
    footerIChing:        'I Ching',
    footerNumerology:    'Numerology',
    footerAstroPet:      'Astro Pet',
    footerPrivacyFull:   'Privacy Policy',
    footerTermsFull:     'Terms of Use',
    footerLgpdFull:      'Data Policy',
    footerCancellation:  'Cancellation',
    footerBusiness:      'For Business',
    footerContact:       'Contact',
    footerCopyright:     '© {year} Professya. All rights reserved.',
    footerDisclaimer:    'Readings are for reflective and entertainment purposes. ✦',
    footerNewsletterDesc: 'Astrological news in your inbox. No spam.',
  },
  forecast: {
    title:          'Forecast',
    emptyTitle:     'Birth date required',
    emptySubtitle:  'Add your birth date to receive personalised forecasts.',
    emptyCta:       'Add data',
    starsMoving:    'The stars are in motion. Please try again in a moment ✦',
    periodToday:    'Today',
    periodWeek:     'This Week',
    periodMonth:    'This Month',
    periodYear:     'This Year',
    loadingDaily:   'Consulting today\'s stars...',
    loadingWeekly:  'Calculating the astrological week...',
    loadingMonthly: 'Analysing the month in the stars...',
    loadingAnnual:  'Preparing your annual forecast...',
    skyNow:              'Sky Now',
    transitShort:        'Today & This Week',
    transitMedium:       'Active for Over 30 Days',
    transitMediumBadge:  'Medium term',
    transitLong:         'Long-term Transformations',
    transitLongBadge:    'Long term',
    transitApproaching:  '↗ Approaching',
    transitPeak:         '◉ At peak',
    transitSeparating:   '↘ Separating',
    transitLongTermChip: '⟳ Long term',
    transitRetrograde:   '® Retrograde',
    illumination:        'illumination',
    regenerateTitle:     'Generate new forecast',
    regenerateCta:       '↺ Regenerate',
    stillThinking:       'The stars are still revealing... ✦',
  },
  tabs: {
    home:      'Home',
    forecast:  'Forecast',
    questions: 'Ask',
    match:     'Match',
    wallet:    'Wallet',
    ariaLabel: 'Main navigation',
    map:       'Chart',
    atlas:     'Local',
    profile:   'Profile',
    search:    'Search',
    today:     'Today',
    me:        'Me',
  },
  pages: {
    onboarding: {
      stepOf: 'Step {step} of {total}',
      welcomeTitle: 'Hello, {name}!',
      welcomeText: 'Welcome to Professya, your space for astrology and esotericism.\nLet\'s set up your personalised experience in a few steps.',
      welcomeCta: 'Get started ✦',
      birthDataTitle: 'Your birth data',
      birthDataDesc: 'Needed to calculate your birth chart. Time is optional but improves accuracy.',
      birthDateLabel: 'Date of birth',
      birthTimeLabel: 'Time of birth',
      birthCityLabel: 'City of birth',
      optional: '(optional)',
      youAreSign: 'You are {sign}!',
      backBtn: 'Back',
      continueBtn: 'Continue',
      skipNow: 'Skip for now',
      skipSetup: 'Skip setup →',
      firstReadingTitle: 'Your first reading',
      firstReadingDesc: 'As {sign}, the stars already have a lot to say to you.',
      firstReadingDesc2: 'With your complete data, the stars can speak directly to you.',
      previewLabel: 'Preview of your dashboard:',
      previewFeat1Label: 'Today\'s forecast',
      previewFeat1Desc: 'Calculated for your natal chart',
      previewFeat2Label: 'Birth Chart',
      previewFeat2Desc: 'Sun, Moon, Ascendant and 8 more planets',
      previewFeat3Label: 'Ask the Stars',
      previewFeat3Desc: '1 free question on new account',
      viewDashboard: 'View my dashboard',
      upgradeTitle: 'Deepen your journey',
      upgradeDesc: 'With Premium you unlock the full birth chart, synastry, personalised forecasts and much more, for less than $1 a day.',
      upgradeF1: 'Full birth chart',
      upgradeF2: 'Relationship synastry',
      upgradeF3: 'Personalised daily forecasts',
      upgradeF4: 'Unlimited questions to the stars',
      upgradeF5: 'AstroMatch by photo',
      upgradeCta: 'Subscribe Premium ✦',
      upgradeFreeCta: 'Continue with free account →',
    },
    birthChart: {
      title: 'Birth Chart',
      houseSystem: 'Precise Calculation',
      howToRead: 'How to read my chart',
      calculating: 'Calculating your planets and astrological houses...',
      planetPositions: 'Planetary Positions',
      planet: 'Planet', sign: 'Sign', degree: 'Degree', house: 'House',
      showAll: 'Show all planets ({n} more)',
      showLess: 'Show less',
      interpretation: 'Interpretation ✦',
      calculateCta: 'Calculate my birth chart',
      retry: '↺ Try again',
      starsMoving: 'The stars are in intense motion now. Please try again in a moment ✦',
      emptyTitle: 'Birth date required',
      emptySubtitle: 'To calculate your birth chart, we need your date of birth. Add it in Profile.',
      emptyCta: 'Go to Profile',
      guideTitle: 'How to read your chart',
      guideCta: 'Got it ✦',
    },
    synastry: {
      title: 'Astrological Compatibility',
      subtitle: 'Synastry',
      partnerDataTitle: 'Partner\'s data',
      partnerNameLabel: 'Name',
      partnerNamePlaceholder: 'Person\'s name',
      partnerSignLabel: 'Sun sign',
      selectSign: 'Select sign',
      partnerDateLabel: 'Date of birth',
      autoAnalyzeHint: 'Analysis starts automatically when this field is filled',
      analyzeCta: 'Analyse compatibility (1 credit)',
      inviteText: 'Would you prefer the other person fills in their own data?',
      generateLink: 'Generate invite link via WhatsApp',
      linkGenerated: 'Link generated:',
      copyBtn: 'Copy',
      compatibility: 'Compatibility',
      noCreditsMsg: 'You have no synastry credits.',
      buyLink: 'Buy →',
      calculating: 'Calculating synastry between {partner} and {user}...',
      newAnalysis: 'New synastry',
      errorMsg: 'Synastry analysis temporarily unavailable. Please try again ✦',
      emptyTitle: 'Birth date required',
      emptySubtitle: 'Add your birth date to perform synastry.',
      emptyCta: 'Go to Profile',
      tabScore: 'Score', tabAnalise: 'Analysis', tabAspectos: 'Aspects',
      tabCasas: 'Houses', tabComposto: 'Composite', tabDavison: 'Davison',
      tabTransitos: 'Transits', tabProgressoes: 'Progressions',
      scoreLove: 'Love & Chemistry', scoreCommunication: 'Communication', scoreValues: 'Values',
      scoreLongTerm: 'Long-term', scoreGrowth: 'Growth', scoreRoutine: 'Routine', scoreFamily: 'Family',
    },
    tarot: {
      title: 'Tarot de Marseille',
      subtitle: 'Classical tradition of Major and Minor Arcana',
      restart: 'Restart',
      intentionMsg: 'Focus on a question...',
      loading: 'The arcana are aligning...',
      generalReading: '✦ General Reading',
      reversed: 'Reversed',
      spreadSingle: 'Card of the Day',
      spreadSingleDesc: '1 card, focus and energy of the moment',
      spreadThree: 'Past · Present · Future',
      spreadThreeDesc: '3 cards, timeline',
      spreadHorseshoe: 'Horseshoe',
      spreadHorseshoeDesc: '7 cards, broad view of the situation',
      spreadCeltic: 'Celtic Cross',
      spreadCelticDesc: '10 cards, deep analysis',
    },
    lenormand: {
      title: 'Lenormand Oracle',
      subtitle: 'The 36-card Gypsy Oracle',
      restart: 'New reading',
      intentionMsg: 'Breathe deeply and focus on your question...',
      loading: 'The cards are being revealed...',
      readingTitle: '✦ Your Reading',
      subscriptionRequired: 'This reading is available for monthly or annual subscribers.',
      spreadSingle: 'Card of the Moment',
      spreadSingleDesc: '1 card, the essential message',
      spreadThree: 'Timeline',
      spreadThreeDesc: '3 cards, past, present and path ahead',
      spreadFive: 'Cross',
      spreadFiveDesc: '5 cards, situation and advice',
      spreadNine: 'Square',
      spreadNineDesc: '9 cards, full reading',
      questionLabel: 'Your question (optional)',
      questionPlaceholder: 'What do you wish to understand? Leave blank for a general reading.',
      questionCta: 'Reveal the cards ✦',
    },
    questions: {
      title: 'Ask the Stars',
      questionLabel: 'Your question',
      questionPlaceholder: 'Write your question for the stars...',
      showExamples: 'See example questions',
      hideExamples: 'Hide examples',
      disclaimer: 'Reflective answers only · Consult professionals for important decisions',
      submitCta: 'Ask (1 credit)',
      submitLoading: 'Consulting the stars...',
      answerTitle: '✦ The stars answer',
      historyTitle: 'Question history',
      noCreditsTitle: 'You don\'t have enough credits. Would you like to restock?',
      noCreditsDesc: 'Your credits ran out. Choose a package below to continue.',
      loading: 'The stars are considering your question...',
      emptyTitle: 'Complete your profile first',
      emptySubtitle: 'Add your date of birth to ask personalised questions to the stars.',
      emptyCta: 'Go to Profile',
    },
    numerology: {
      title: 'Numerology',
      subtitle: 'The numbers that govern your journey',
      intro: 'Calculate your complete numerology map based on your name and date of birth.',
      calculateCta: 'Calculate my numerology ✦',
      calculating: 'The numbers are being calculated...',
      lifePathLabel: 'Life Path',
      destinyLabel: 'Destiny',
      soulLabel: 'Soul',
      personalityLabel: 'Personality',
      newConsult: 'New reading',
      error: 'The numbers are aligning. Please try again in a moment ✦',
      emptyTitle: 'Data required',
      emptySubtitle: 'Add your name and date of birth in your profile to calculate your numerology.',
      emptyCta: 'Go to Profile',
      tabSinteseGeral: 'General Synthesis', tabCaminhoDeVida: 'Life Path',
      tabDestino: 'Destiny Number', tabAlma: 'Soul Number', tabPersonalidade: 'Personality',
    },
    iching: {
      title: 'I Ching',
      subtitle: 'The Book of Changes',
      intro: 'The I Ching consults the patterns of universal change to reveal the essence of your situation.',
      questionLabel: 'Your question',
      questionPlaceholder: 'What do you wish to understand?',
      throwingCoins: 'Throwing the coins...',
      consultCta: 'Consult the oracle ✦',
      throwingMsg: 'Throwing the sacred coins...',
      interpretingMsg: 'The oracle is interpreting the changes...',
      hexagramLabel: 'Hexagram {n}, {name}',
      transformsInto: 'Transforms into: Hexagram {n}',
      newConsult: 'New reading',
      error: 'The oracle is silent. Please try again in a moment ✦',
    },
    dreamJournal: {
      title: 'Dream Journal',
      subtitle: 'Uncover the messages of the unconscious',
      dreamLabel: 'Describe your dream',
      dreamPlaceholder: 'Describe in detail what you dreamed... People, places, feelings, colours...',
      interpretCta: 'Interpret my dream ✦',
      loading: 'Diving into the layers of the unconscious...',
      symbolsTitle: '✦ Identified symbols',
      interpretationTitle: '✦ Interpretation',
      guidanceTitle: '✦ Guidance',
      historyTitle: 'Journal',
      newEntry: 'Record another dream',
      error: 'The unconscious is silent. Please try again in a moment ✦',
    },
    moonPhases: {
      title: 'Moon Phases',
      subtitle: 'Lunar calendar and cycle energies',
      illuminated: '{n}% illuminated',
      upcomingPhases: '✦ Upcoming phases',
      ritualsFor: '✦ Rituals for {phase}',
    },
    humanDesign: {
      title: 'Human Design',
      subtitle: 'Your life type and strategy',
      intro: 'Discover your Human Design type, life strategy and inner authority to make decisions with clarity.',
      calculateCta: 'Calculate my Human Design ✦',
      calculating: 'Calculating your Human Design...',
      birthTimeWarning: '✦ Birth time recommended',
      birthTimeWarningDesc: 'Human Design is more accurate with your birth time. Without it, we\'ll use an approximate calculation.',
      addBirthTime: 'Add birth time →',
      profileLabel: 'Profile',
      authorityLabel: 'Authority',
      strategyLabel: 'Strategy',
      signatureLabel: 'Signature',
      notSelfLabel: 'Not-Self',
      centersTitle: '✦ Centers',
      recalculate: 'Recalculate',
      error: 'The Human Design system is being analysed. Please try again in a moment ✦',
      emptyTitle: 'Birth date required',
      emptySubtitle: 'Add your date of birth to calculate your Human Design.',
      emptyCta: 'Go to Profile',
    },
    vedicAstrology: {
      title: 'Vedic Astrology',
      subtitle: 'Jyotish, the Science of Light',
      intro: 'Vedic astrology (Jyotish) is an ancient Indian system using the sidereal zodiac, revealing deep layers of destiny, karma and purpose.',
      consultCta: 'Consult Jyotish ✦',
      loading: 'Calculating the Vedic chart...',
      addBirthTime: '✦ Adding your birth time makes the reading much more accurate.',
      keyPositions: '✦ Key positions',
      ascLabel: 'Ascendant (Lagna)',
      moonLabel: 'Moon sign',
      sunLabel: 'Sun sign',
      nakshatraLabel: 'Nakshatra',
      dashaLabel: 'Current Dasha',
      yogasLabel: 'Present Yogas',
      newConsult: 'New reading',
      error: 'The Vedic stars are aligning. Please try again in a moment ✦',
      emptyTitle: 'Birth date required',
      emptySubtitle: 'Add your date of birth to access Vedic astrology.',
      emptyCta: 'Go to Profile',
    },
    astromatch: {
      title: 'AstroMatch',
      subtitle: 'Astrological analysis by physiognomy',
      subjectNameLabel: 'Person\'s name',
      subjectNameOptional: '(optional)',
      subjectNamePlaceholder: 'e.g. John',
      cameraBtn: 'Camera / Gallery',
      noConsent: '↑ Accept the terms above to enable photo upload',
      newAnalysis: 'New analysis',
      errorMsg: 'We couldn\'t process the analysis. Please try again ✦',
      errorRetry: 'Try with another photo',
      loading1: 'Analysing facial features...',
      loading2: 'Consulting the stars...',
      loading3: 'Calculating the natal chart...',
      loading4: 'Preparing your analysis ✦',
    },
    quiromancy: {
      title: 'Palmistry',
      subtitle: 'Reading the lines of the hand',
      handSelectorLabel: 'Which hand would you like to analyse?',
      rightHand: 'Right Hand',
      leftHand: 'Left Hand',
      rightHandHint: 'Right hand, destiny and present',
      leftHandHint: 'Left hand, innate potential',
      instructions: 'Photograph the open palm with good lighting and a light background.',
      handTypeLabel: '✦ Hand type',
      cameraBtn: 'Camera / Gallery',
      noConsent: '↑ Accept the terms above to enable photo upload',
      newAnalysis: 'New analysis',
      errorMsg: 'We could not read the lines in this image. Make sure the palm is clearly visible and well lit.',
      errorRetry: 'Try with another photo',
      loading1: 'Analysing the lines of the hand...',
      loading2: 'Identifying the mounts...',
      loading3: 'Consulting the stars...',
      loading4: 'Preparing your reading ✦',
    },
    startAstral: {
      tabTalentos: 'Talents', tabDesafios: 'Challenges', tabAmbientes: 'Environments',
      tabLideranca: 'Leadership', tabAreas: 'Professional Areas', tabCaminhos: 'Challenging Paths', tabCiclos: 'Cycles',
      tabVocacional: 'Vocational Map', tabAtual: 'Current Career', tabAlmejada: 'Desired Role', tabTransicao: 'Transition',
    },
    readings: {
      title: 'Readings',
      subtitle: 'Your consultation history',
      emptyAll: 'No readings found yet.',
      emptyFilter: 'No readings of this type yet.',
      reading: 'Reading',
    },
    notFound: {
      title: 'Page not found',
      body:  'The stars could not locate this page. Perhaps it got lost in the cosmos.',
      back:  'Back to home',
    },
    servicos: {
      heroCtaStart:          'Start now',
      heroCtaAccess:         'Access',
      heroBadgeFree:         'Available on every plan',
      heroBadgeMonthly:      'Available from the Monthly Plan',
      heroBadgeAnnual:       'Exclusive to the Annual Plan',
      tierFree:              'Free',
      tierMonthly:           'Monthly',
      tierAnnual:            'Annual',
      benefitsTitle:         "What you'll discover",
      forWhoTitle:           'This service is for you if...',
      previewTitle:          "A taste of what you'll receive",
      previewSubtitle:       'Illustrative example, your analysis is always unique',
      previewUnlock:         '✦ Unlock your full analysis',
      plansTitle:            'Choose your plan and start now',
      plansRecommended:      '✦ RECOMMENDED FOR THIS SERVICE',
      testimonialsTitle:     'What our users are saying',
      faqTitle:              'Frequently asked questions',
      finalCtaTitle:         'Start now and receive your analysis in moments',
      finalCtaAnonDesc:      'It takes less than a minute to create your account and explore the Professya universe.',
      finalCtaCreateAccount: 'Create free account',
      finalCtaHaveAccount:   'I already have an account',
      comingSoonBtn:         'Coming soon ✦',
      comingSoonBadge:       'Launching soon',
      comingSoonDesc:        "We're putting the final touches. You'll be able to access this service on Professya very soon.",
    },
    profile: {
      title:    'My Account',
      subtitle: 'Manage your information and security.',
      planSection:  'My Plan',
      currentPlan:  'Current plan:',
      planFree:     'Free',
      planMonthly:  'Monthly',
      planAnnual:   'Annual',
      planFreeFull:    'Free',
      planMonthlyFull: 'Professya Monthly',
      planAnnualFull:  'Professya Annual',
      cancelCta:    'Cancel subscription',
      cancelPrompt: 'We\'ll miss you. If you\'d like to tell us why (optional):',
      cancelReasonPricey:        'Too expensive',
      cancelReasonUnused:        'I don\'t use it as much as I expected',
      cancelReasonPause:         'I\'m taking a break and will return',
      cancelReasonOtherPlatform: 'Found another platform',
      cancelReasonMisc:          'Other reason',
      cancelConfirmCta: 'Cancel my subscription',
      cancelling:       'Cancelling...',
      cancelError:      'Could not cancel. Please try again or contact us.',
      cancelBack:       'Back',
      accountSection:   'Account information',
      nameLabel:        'Name:',
      emailLabel:       'Email:',
      planLabel:        'Plan:',
      birthSection:     'Birth data',
      birthEditBtn:     'Edit',
      birthDateLabel:   'Date:',
      birthTimeLabel:   'Time:',
      birthCityLabel:   'City:',
      birthTimeNotSet:  'Not provided',
      birthSaveSuccess: 'Data updated. Recalculating your natal chart...',
      birthDateFormLabel: 'Birth date',
      birthTimeFormLabel: 'Birth time (optional)',
      birthCityFormLabel: 'Birth city',
      birthCityPlaceholder: 'e.g. London, UK',
      saveCta:      'Save',
      savingCta:    'Saving...',
      cancelEditCta: 'Cancel',
      confirmTitle: 'Recalculate natal chart?',
      confirmDesc:  'Changing your birth date will recalculate your natal chart. Previous readings will not be affected, but new ones will use the updated data.',
      confirmCta:   'Confirm and recalculate',
      securitySection: 'Security',
      genderLabel: 'Gender:', genderM: 'Male', genderF: 'Female', genderNB: 'Non-binary', genderNotSay: 'Prefer not to say',
      birthLimitError: 'You have reached the limit of 2 birth data changes. Please contact support to request a correction.',
    },
  },
  shared: {
    privacyTitle: 'Your privacy is a priority',
    privacyDesc: 'The photo is processed only for analysis and is never saved on our servers. Geolocation data (EXIF) is removed before sending.',
    privacyConsent: '✓ Understood, the photo will not be saved. I accept to proceed.',
    feedbackQuestion: 'Was this reading helpful?',
    feedbackThanks: 'Thank you for your feedback!',
    shareWhatsApp: 'Share my Astral Secret ✦',
    shareCopied: 'Text copied! Paste on WhatsApp ✦',
    shareError: 'Could not share. Try copying the text manually.',
    buyCredits: 'Buy credits ✦',
    newConsult: 'New reading',
    retry: 'Try again',
  },
};

export default en;
